// import React, { useState } from "react";
// import { Carousel } from "react-bootstrap";
// // import greystorm from '../../../../images/storm/greystorm.webp';
// // import blackstorm from '../../../../images/storm/blackstorm.webp';
// // import whitestorm from '../../../../images/storm/whitestorm.webp';
// const greystorm ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fgreystorm.webp?alt=media&token=88578df8-040a-40d2-8042-60dca00b7c8a"
// const blackstorm ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fblackstorm.webp?alt=media&token=5306a755-b1c2-4de9-9802-df841efe2b7b"
// const whitestorm ="https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fwhitestorm.webp?alt=media&token=c9f0ddfc-39b2-49d8-a14e-403e257f7a0f"
// const CustomCarousel = () => {
//   const [activeIndex, setActiveIndex] = useState(null);
//   const [fixedImage, setFixedImage] = useState(whitestorm); 

//   const carImages = [
//     { src: whitestorm, alt: "whitestorm", color: "#FDFCFF" },
//     { src: greystorm, alt: "greystorm", color: "#413D3A" },
//     { src: blackstorm, alt: "blackstorm", color: "black" },
//   ];

//   const handleSelect = (index) => {
//     setActiveIndex(index);
//     setFixedImage(carImages[index].src); 
//   };

//   return (
//     <div style={{ position: "relative",margin:0,padding:0 }}>
//       <Carousel 
//         activeIndex={activeIndex} 
//         onSelect={handleSelect} 
//         interval={null} 
//         pause={false}
//         indicators={false}
//         controls={false}
//       >
//         {carImages.map((car, index) => (
//           <Carousel.Item key={index}>
//             <img className="d-block w-100" src={fixedImage} alt={car.alt} />
//           </Carousel.Item>
//         ))}
//       </Carousel>

//       {/* Custom Circle Indicators */}
//       <div style={{ position: "absolute", bottom: "7px", left: "50%", transform: "translateX(-50%)", display: "flex", gap: "12px" }}>
//         {carImages.map((car, index) => (
//           <div
//             key={index}
//             onClick={() => handleSelect(index)}
//             style={{
//               width: "23px",
//               height: "22px",
//               borderRadius: "50%",
//               backgroundColor: activeIndex === index ? car.color : car.color, 
//               cursor: "pointer",
//             }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default CustomCarousel;






























import React, { useState } from "react";

const CustomCarousel = () => {
  const carImages = [
    {
      name: "greystorm",
      color: "#413D3A",
      // textColor: "greystorm",
      image:
        "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fgreystorm.webp?alt=media&token=88578df8-040a-40d2-8042-60dca00b7c8a",
    },
    {
      name: "blackstorm",
      color: "#000000",
      // textColor: "black",
      image:
        "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fblackstorm.webp?alt=media&token=5306a755-b1c2-4de9-9802-df841efe2b7b",
    },
    {
      name: "whitestorm",
      color: "#FDFCFF",
      // textColor: "",
      image:
        "https://firebasestorage.googleapis.com/v0/b/mgcentral-33fa0.firebasestorage.app/o/Gloster%2Fterrain%2Fwhitestorm.webp?alt=media&token=c9f0ddfc-39b2-49d8-a14e-403e257f7a0f",
    },
    // {
    //   name: "Pearl White",
    //   color: "#ffffff",
    //   textColor: "#000000",
    //   image:
    //     "https://www.mgmotor.co.in/content/dam/mgmotor/vehicles/mg-majestor/images/mg-banner/mgbanner-img-004.png",
    // },
  ];

  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      <section
        className="car-section"
        style={{
          background: carImages[activeIndex].color,
          color: carImages[activeIndex].textColor,
        }}
      >
        <img
          src={carImages[activeIndex].image}
          alt="MG Majestor"
          className="car-image"
        />

        <div
          className="color-name"
          style={{
            background:
              carImages[activeIndex].textColor === "#ffffff"
                ? "#000"
                : "#fff",
            color: carImages[activeIndex].textColor,
          }}
        >
          {carImages[activeIndex].name}
        </div>

        <div className="color-options">
          {carImages.map((item, index) => (
            <button
              key={index}
              className={`color-btn ${
                activeIndex === index ? "active" : ""
              }`}
              style={{ background: item.color }}
              onClick={() => setActiveIndex(index)}
            ></button>
          ))}
        </div>
      </section>

      <style>{`
        .car-section {
          width: 100%;
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 40px 20px;
          text-align: center;
          transition: background 0.6s ease, color 0.6s ease;
        }

        .car-image {
          width: 75%;
          max-width: 900px;
          transition: 0.4s ease-in-out;
        }

        .color-name {
          margin-top: 20px;
          padding: 6px 14px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          transition: 0.4s ease;
        }

        .color-options {
          margin-top: 20px;
          display: flex;
          gap: 18px;
        }

        .color-btn {
          width: 26px;
          height: 26px;
          border-radius: 50%;
          border: 2px solid #ddd;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .color-btn.active {
          border: 3px solid #fff;
          transform: scale(1.15);
        }

        .color-btn:hover {
          transform: scale(1.1);
        }

        @media (max-width: 991px) {
          .car-image {
            width: 90%;
          }
        }

        @media (max-width: 576px) {
          .car-image {
            width: 100%;
          }

          .color-options {
            gap: 14px;
          }

          .color-btn {
            width: 22px;
            height: 22px;
          }
        }
      `}</style>
    </>
  );
};

export default CustomCarousel;

